export function getAcronym(text: string) {
  return text
    .split(" ")
    .map(function (item) {
      return item[0];
    })
    .join("");
}
